export const toggleView = () => {
  const btnToggleView = ".js-toggle-view";
  const locationsView = ".js-view-container";

  const init = () => {
    bind();
  };

  const bind = () => {
    $(btnToggleView).on("click", function(e) {
      e.preventDefault();
      var clicked_item = $(this);
      clicked_item
        .addClass("is-active")
        .siblings()
        .removeClass("is-active");
      var view = clicked_item.attr("data-view");
      toggle(view);
    });
  };

  const toggle = (view) => {
    $(locationsView).attr("data-view", view);
  };

  init();
};
